// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { requestGetSurveyResults } from "../../../../state/survey/SurveysEffects";
import i18n from "i18next";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import {
  SurveyInfoResponseDTO,
  SurveyResultsResponseDTO
} from "../../../../api/backend-openapi";

type SurveyTypeProps = {
  record: SurveyInfoResponseDTO;
};

const SurveyVote: React.FunctionComponent<SurveyTypeProps> = (
  props: SurveyTypeProps
) => {
  const { record } = props;
  const [results, setResults] = useState<SurveyResultsResponseDTO | null>(null);

  useEffect(() => {
    if (record && record.publicationDate !== null) {
      requestGetSurveyResults(record.id).then(result => {
        if (result.ok && result.data) {
          setResults(result.data);
        }
      });
    }
  }, [record]);

  return results ? (
    <span> {results.nbResponses + " " + i18n.t("detail_survey.votes")} </span>
  ) : (
    <CloseOutlined style={{ color: "red" }} />
  );
};
export default SurveyVote;
